import { render, staticRenderFns } from "./indexnew.vue?vue&type=template&id=04444e72&scoped=true&"
import script from "./indexnew.vue?vue&type=script&lang=js&"
export * from "./indexnew.vue?vue&type=script&lang=js&"
import style0 from "./indexnew.vue?vue&type=style&index=0&id=04444e72&lang=less&scoped=true&"
import style1 from "./indexnew.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04444e72",
  null
  
)

export default component.exports